var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex-around-center mx-20 mt-5 text-bold" },
    [
      _vm.msg ? _vm._t("default") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "whitespace-wrap flex-center-center gap-2",
          class: _vm.msgClass,
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.msg))]),
          _c("i", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.processing,
                expression: "processing",
              },
            ],
            staticClass: "loading",
          }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }